<template><Rates /></template>
<script>
import Rates from "@/components/Dashboard/Rates/Rates.vue";

export default {
  components: { Rates },
};
</script>
